import React from "react";

const SceneContext = React.createContext();

export default SceneContext;
